import { MdsIconKind } from "@/design-system/components/icon";
import { IMDSIconButtonProps } from "@/mds";

export const getIconKind = ({
  isSelected,
  isHighlighted,
  defaultIcon,
}: {
  isSelected?: boolean;
  isHighlighted?: boolean;
  defaultIcon: IMDSIconButtonProps["iconKind"];
}) => {
  if (isSelected) {
    return MdsIconKind.CheckboxSolid;
  }

  if (isHighlighted) {
    return MdsIconKind.CheckboxEmpty;
  }

  return defaultIcon;
};
